import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getCustomerFeatureFlags } from '@api';

export const coreCustomersCurrentFeatureFlagsGetAsyncSlice = createGetAsyncSlice({
	name: 'CoreCustomersCurrentFeatureFlags',
	receive: true,
	request: false,
	requestHandler: () => getCustomerFeatureFlags({})
});
